<template>
    <form class="login100-form flex-sb flex-w mt-4">
        <span class="login100-form-title pb-3">Đăng nhập</span>

        <div class="pb-3 w-100">
            <span v-if="error_server" class="error-message">{{error_server}}</span>
        </div>

        <span class="txt1 pb-2">Tài khoản/Số ĐT</span>
        <div class="mb-3 w-100">
            <div class="wrap-input100">
                <input v-model="$v.form.username.$model"
                       class="input100"
                       type="text"
                       name="username">
                <span class="focus-input100"></span>
            </div>
            <div v-if="$v.form.username.$error">
                <span class="error-message" v-if="!$v.form.username.required">Tài khoản không được để trống</span>
            </div>
        </div>


        <span class="txt1 pb-2">Mật khẩu</span>
        <div class="mb-4 w-100">
            <div class="wrap-input100">
                <input v-model="$v.form.password.$model"
                       class="input100"
                       type="password"
                       name="password">
                <span class="focus-input100"></span>
            </div>
            <div v-if="$v.form.password.$error">
                <span class="error-message" v-if="!$v.form.password.required">Mật khẩu không được để trống</span>
            </div>
        </div>


<!--        <div class="flex-sb-m w-100 pb-3">-->
<!--            <div>-->
<!--                <a href="#" class="txt2">-->
<!--                    Quên mật khẩu?-->
<!--                </a>-->
<!--            </div>-->
<!--        </div>-->

        <div class="container-login100-form-btn">
            <button type="button" class="login100-form-btn" @click="submit" :disabled="isSubmitting">
                Đăng nhập
            </button>
        </div>
    </form>
</template>

<script>

    import required from 'vuelidate/lib/validators/required'
    import {AUTH_LOGIN} from "../../../store/actions/Auth";
    import {MixinHelper} from "../../shared/services";
    export default {
        name: "Login",
        mixins: [MixinHelper],
        data() {
            return {
                form: {
                    username: '',
                    password: ''
                },
                error_server: null,
                isSubmitting: false
            }
        },
        validations: {
            form: {
                username: {
                    required
                },
                password: {
                    required
                }
            }
        },
        methods: {
            submit() {
                this.isSubmitting = true;
                const self = this;
                this.$v.$touch();
                if (this.$v.$error || this.$v.$pending) {
                    return;
                }
                this.$store.dispatch(AUTH_LOGIN, this.form)
                    .then(resp => {
                        this.$modalAuth.hide();
                    })
                    .catch(err => {
                        this.error_server = this.getProp(err, 'response.data.message', 'Thất bại vì lí do bất ngờ');
                    })
                    .finally(() => {
                        self.isSubmitting = false;
                    })
            }
        }
    }
</script>

<style scoped>
    @import "../../../assets/css/auth.css";
</style>
